"use strict";

var baseFontStack = 'Helvetica Neue, Helvetica, Arial, sans-serif';
var webFontStack = "SoDoSans, ".concat(baseFontStack);
module.exports = {
  typefaceLoading: {
    value: baseFontStack
  },
  typefacePrimary: {
    value: webFontStack
  },
  textSize1: {
    value: '1.3rem'
  },
  textSize2: {
    value: '1.4rem'
  },
  textSize3: {
    value: '1.6rem'
  },
  textSize4: {
    value: '1.9rem'
  },
  textSize5: {
    value: '2.0rem'
  },
  textSize6: {
    value: '2.2rem'
  },
  textSize7: {
    value: '2.4rem'
  },
  textSize8: {
    value: '2.8rem'
  },
  textSize9: {
    value: '3.6rem'
  },
  textSize10: {
    value: '5.0rem'
  },
  letterSpacingNormal: {
    value: '-0.01em'
  },
  letterSpacingLoose: {
    value: '0.1em'
  },
  letterSpacingLooser: {
    value: '0.15em'
  },
  lineHeightNormal: {
    value: '1.5'
  },
  lineHeightCompact: {
    value: '1.2'
  }
};